import { ProductConfigurationIds } from './../models/cart-model';
import { of } from 'rxjs';
import { ConstantsService } from './constants.service';
import { mergeMap } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "./questionnaire/questionnaire-mapping.service";
import * as i2 from "./questionnaire/questionnaire.service";
import * as i3 from "../state/app/app.service";
import * as i4 from "@legalzoom/product-sdk";
import * as i5 from "@legalzoom/questionnaire-answer-sdk";
export class PackageService {
    constructor(questionnaireMappingService, questionnaireService, appService, productService, questionAnswerService) {
        this.questionnaireMappingService = questionnaireMappingService;
        this.questionnaireService = questionnaireService;
        this.appService = appService;
        this.productService = productService;
        this.questionAnswerService = questionAnswerService;
    }
    getPackages() {
        if (!this.packageConfigurations) {
            return this.loadPackages();
        }
        else {
            return of(this.packageConfigurations);
        }
    }
    loadPackages() {
        const mappedUserAnswer = this.questionnaireMappingService.doMapping(this.questionnaireService.llc, this.appService.processingOrderId);
        const userAnswerRequest = {
            questionnaireFieldGroupAnswers: {
                userOrderId: mappedUserAnswer.userOrderId,
                questionnaireId: this.appService.questionnaireId,
                fieldAnswers: mappedUserAnswer.fieldAnswers,
                groupAnswers: []
            }
        };
        const customerStateAbbr = ConstantsService.getStateByName(this.questionnaireService.llc.entityState).abbr;
        return this.questionAnswerService.saveAndGetMappedUserAnswers(userAnswerRequest, this.appService.app.questionnaireId, this.appService.app.customerId).pipe(mergeMap((saveUserAnswerResponse) => {
            const productFilingRequest = {
                fieldAnswers: saveUserAnswerResponse.questionnaireFieldGroupAnswers.fieldAnswers,
                groupAnswers: saveUserAnswerResponse.questionnaireFieldGroupAnswers.groupAnswers,
                state: customerStateAbbr,
            };
            return this.productService.getAvailablePackagesWithFilingFees(this.appService.app.processId, productFilingRequest, this.appService.app.customerId).pipe(mergeMap(productFilingResponse => {
                return this.mapPackageConfigurations(productFilingResponse);
            }));
        }));
    }
    mapPackageConfigurations(productFilingFees) {
        const packageConfigurations = {
            packageConfiguration: []
        };
        for (const productFilingFee of productFilingFees.packages) {
            const packageConfiguration = {
                name: productFilingFee.productName,
                parentProductId: null,
                productComponentId: null,
                productConfigurationId: productFilingFee.productConfigurationId,
                displayNameOnBill: productFilingFee.billingDisplayName,
                displayNameOnWeb: productFilingFee.purchaseLockDisplayName,
                packageProductConfigurationId: null,
                productTypeId: '',
                shouldDisplayOnBill: false,
                productComponent: null,
                isDefaultPackage: false,
                childProducts: null,
                extendedPrice: productFilingFee.adjustedPrice,
                filingfees: {
                    productBasePriceId: productFilingFee.filingFee ? productFilingFee.filingFee.productBasePriceId : null,
                    productPricePointId: productFilingFee.filingFee ? productFilingFee.filingFee.productPricePointId : null,
                    productPriceAdjustmentId: productFilingFee.filingFee ? productFilingFee.filingFee.productPriceAdjustmentId : null,
                    basePrice: productFilingFee.filingFee ? productFilingFee.filingFee.basePrice : null,
                    lawyerAmount: productFilingFee.filingFee ? productFilingFee.filingFee.lawyerAmount : null,
                    adjustedPrice: productFilingFee.filingFee ? productFilingFee.filingFee.adjustedPrice : null,
                    stateId: productFilingFee.filingFee ? productFilingFee.filingFee.stateId : null,
                    countyId: productFilingFee.filingFee ? productFilingFee.filingFee.countyId : null,
                    productName: productFilingFee.filingFee ? productFilingFee.filingFee.productName : null,
                    billingDisplayName: productFilingFee.filingFee ? productFilingFee.filingFee.billingDisplayName : null,
                    purchaseLockDisplayName: productFilingFee.filingFee ? productFilingFee.filingFee.purchaseLockDisplayName : null
                }
            };
            packageConfigurations.packageConfiguration.push(packageConfiguration);
        }
        return of(packageConfigurations);
    }
    createNewPackageConfiguration() {
        return {
            name: '',
            parentProductId: 0,
            productComponentId: 0,
            productConfigurationId: 0,
            displayNameOnBill: '',
            displayNameOnWeb: '',
            packageProductConfigurationId: '',
            extendedPrice: 0,
            filingfees: null,
            productTypeId: '',
            shouldDisplayOnBill: false,
            productComponent: null,
            isDefaultPackage: false,
            childProducts: null
        };
    }
    getPackageDisplayName(pkg) {
        switch (pkg.productConfigurationId) {
            case ProductConfigurationIds.economyLLCPackage:
                return 'Economy';
            case ProductConfigurationIds.standarLLCPackage:
                return 'Standard';
            case ProductConfigurationIds.expressGoldLLCPackage:
                return 'Express Gold';
            case ProductConfigurationIds.tier1LLCPackage:
                return 'Get Me Started';
            case ProductConfigurationIds.tier2LLCPackage:
                return 'Support Me';
            case ProductConfigurationIds.tier3LLCPackage:
                return 'Help Me Grow';
            default:
                return pkg.displayNameOnBill;
        }
    }
}
PackageService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function PackageService_Factory() { return new PackageService(i0.ɵɵinject(i1.QuestionnaireMappingService), i0.ɵɵinject(i2.QuestionnaireService), i0.ɵɵinject(i3.AppService), i0.ɵɵinject(i4.ProductService), i0.ɵɵinject(i5.QuestionnaireAnswerService)); }, token: PackageService, providedIn: "root" });
